document.addEventListener('DOMContentLoaded', function () {
  var hh = document.getElementById('announce-hh');
  var mm = document.getElementById('announce-mm');
  var ss = document.getElementById('announce-ss');
  if (!hh || !mm || !ss) return;

  var total = 8 * 3600 + 42 * 60 + 17;
  setInterval(function () {
    total = total > 0 ? total - 1 : 8 * 3600 + 59 * 60 + 59;
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    hh.textContent = String(h).padStart(2, '0');
    mm.textContent = String(m).padStart(2, '0');
    ss.textContent = String(s).padStart(2, '0');
  }, 1000);
});
